import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { SENTRY_URL } from './config';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

Sentry.init({
  dsn: SENTRY_URL ,
  integrations: [new BrowserTracing()],
  allowUrls:[
    /https:\/\/corsi\.croas-sicilia\.it/,
    /http:\/\/localhost:3000/
  ],
  
  beforeSend(event, hint) {
    const error = hint.originalException;
    if (
      error &&
      error.message &&
      (
      error.message.match(/EncodingError/i)
      )
    ){
      return null
    }
    else return event
  },
  tracesSampleRate: 0.1,
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

reportWebVitals();
